import { useTranslation } from "react-i18next";

import { AuthStatusScreen } from "@/components/auth/AuthStatusScreen";

/**
 * Public landing when a payment short-link no longer resolves —
 * the row was deleted, already paid, cancelled, or never existed.
 *
 * Reached from the backend's /p/:token and /pay/c/:checkoutId
 * controllers redirecting here instead of returning a raw 404 JSON.
 * The buyer is the accountant's client, not authenticated.
 */
export function LinkNotAvailablePage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <AuthStatusScreen
      state="info"
      title={t("pay.linkNotAvailableTitle", "Este enlace ya no está disponible")}
      message={t(
        "pay.linkNotAvailableMessage",
        "El enlace que abriste fue usado, cancelado o caducó. Si necesitabas pagar, pedile a tu contador uno nuevo.",
      )}
    />
  );
}
